
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Find the root element
const rootElement = document.getElementById('root');

// Ensure the root element exists
if (!rootElement) {
  console.error('Root element not found!');
} else {
  // Create the React root and render the App
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )
}
